import AvoidTouching from './AvoidTouching';
import GoHome from './GoHome';
import WearFaceCovering from './WearFaceCovering';

export default { AvoidTouching, GoHome, WearFaceCovering };
